module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.8-265.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.8.md
// module id = 709
// module chunks = 236